const inFlightRequests = new Map<string, Promise<any>>();
const resolvedRequests = new Map<string, any>();

interface ShortlistPriceBreakupParams {
  variantSlug: string;
  cityName: string;
  colorSlug?: string;
}

const buildShortlistPriceBreakupUrl = ({
  variantSlug,
  cityName,
  colorSlug = "",
}: ShortlistPriceBreakupParams) =>
  `/api/price-breakup-v2/?slug=${encodeURIComponent(
    variantSlug,
  )}&city=${encodeURIComponent(cityName)}&color=${encodeURIComponent(
    colorSlug,
  )}`;

const hasRequiredPriceBreakupParams = ({
  variantSlug,
  cityName,
}: ShortlistPriceBreakupParams) =>
  Boolean(variantSlug?.trim() && cityName?.trim());

export const fetchShortlistPriceBreakup = ({
  variantSlug,
  cityName,
  colorSlug,
}: ShortlistPriceBreakupParams): Promise<any> => {
  if (!hasRequiredPriceBreakupParams({ variantSlug, cityName })) {
    return Promise.resolve(undefined);
  }

  const url = buildShortlistPriceBreakupUrl({
    variantSlug: variantSlug.trim(),
    cityName: cityName.trim(),
    colorSlug: colorSlug?.trim(),
  });

  if (resolvedRequests.has(url)) {
    return Promise.resolve(resolvedRequests.get(url));
  }

  const existing = inFlightRequests.get(url);

  if (existing) {
    return existing;
  }

  const promise = fetch(url)
    .then((res) => {
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }

      return res.json();
    })
    .then((data) => {
      resolvedRequests.set(url, data);
      return data;
    })
    .finally(() => {
      inFlightRequests.delete(url);
    });

  inFlightRequests.set(url, promise);

  return promise;
};

export const fetchCachedPriceBreakupV2 = fetchShortlistPriceBreakup;
